export default __webpack_public_path__ + "static/media/bathroom1-after-2048w.38c89a25.avif";